import { render, staticRenderFns } from "./TransferGame.vue?vue&type=template&id=086f229d&scoped=true"
import script from "./TransferGame.vue?vue&type=script&lang=js"
export * from "./TransferGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f229d",
  null
  
)

export default component.exports